import { get } from "lodash";
import Dinero from "dinero.js";
import React, { Fragment, PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Field } from "formik";
import { Grid, Loader } from "semantic-ui-react";

import FormikSemanticDropdown from "./formik/FormikSemanticDropdown.jsx";
import LabelWithHelpPopup from "../labelWithHelpPopup/LabelWithHelpPopup.jsx";

import { MARKING_STATES } from "../../utils/marking.js";
import { COST_FORMAT } from "../config.js";

import estimateSelector from "../../state/reducers/estimates/estimateSelector.js";
import {
  selectSize,
  selectSizesList
} from "../../state/reducers/resources/resourceSelector.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";
import { AT_TYPES_TO_RESOURCE_KEYS } from "../../constants/entity.js";

class EditSizeBlock extends PureComponent {
  static propTypes = {
    data: PropTypes.object.isRequired,
    estimates: PropTypes.array,
    resizeAvailability: PropTypes.object.isRequired,
    violationErrors: PropTypes.object,
    copyKey: PropTypes.string.isRequired,

    estimateIsAvailable: PropTypes.bool,
    isFetching: PropTypes.bool.isRequired,
    sizesList: PropTypes.array.isRequired,
    selectedSize: PropTypes.object.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "resource.details_panel"
  };

  renderCharge = estimate => {
    const resourceKey = AT_TYPES_TO_RESOURCE_KEYS[this.props.data["@type"]];

    const charge = get(estimate, `${resourceKey}.weekly.charge.value`, 0);
    const currency = get(
      estimate,
      `${resourceKey}.weekly.charge.currency`,
      "GBP"
    );

    return Dinero({
      amount: Math.round(charge), // this should be prerounded by the api
      currency: currency
    }).toFormat(COST_FORMAT);
  };

  render() {
    const {
      data: { marking, size },
      estimates,
      isFetching,
      violationErrors,
      sizesList,
      selectedSize,
      resizeAvailability: { permitted, enabled, available },
      estimateIsAvailable,
      copyKey,
      copy
    } = this.props;

    const showEstimates =
      estimateIsAvailable &&
      !isFetching &&
      estimates &&
      selectedSize["@id"] !== size["@id"];

    if (available) {
      return (
        <Fragment>
          <br />
          <Field
            name="size"
            label={copy(`${copyKey}.size_placeholder`)}
            placeholder={copy(`${copyKey}.size_label`)}
            help={selectedSize.description}
            options={sizesList}
            required={true}
            apiErrors={violationErrors}
            component={FormikSemanticDropdown}
          />

          {isFetching && <Loader active inline size="small" />}

          {showEstimates && (
            <Fragment>
              <p className="small-text">
                {copy(`${copyKey}.estimate.description`)}
              </p>
              <Grid stackable className="clear-both break-word small-text">
                <Grid.Row columns={2}>
                  <Grid.Column width={4}>
                    <b>
                      {copy(`${copyKey}.estimate.current`)}:{" "}
                      {this.renderCharge(estimates[0])}
                    </b>
                    <br />
                    {size.name}
                  </Grid.Column>
                  <Grid.Column>
                    <b>
                      {copy(`${copyKey}.estimate.updated`)}:{" "}
                      {this.renderCharge(estimates[1])}
                    </b>
                    <br />
                    {selectedSize.name}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Fragment>
          )}
        </Fragment>
      );
    }

    if (permitted && !enabled && marking !== MARKING_STATES.STOPPED) {
      return (
        <Fragment>
          <div className="field">
            <label>{copy(`${copyKey}.size_placeholder`)}</label>
            <LabelWithHelpPopup
              label={get(size, "name", "")}
              help={get(size, "description", "")}
            />
          </div>
          <p>{copy(`${copyKey}.size_not_stopped_message`)}</p>
        </Fragment>
      );
    }

    return null;
  }
}

const mapStateToProps = (state, props) => ({
  estimateIsAvailable: estimateSelector.selectEstimateIsAvailabile(
    state,
    props
  ),
  estimates: estimateSelector.selectEstimatesByAtIDs(["current", "updated"])(
    state,
    props
  ),
  isFetching: state.estimates.isFetching,
  sizesList: selectSizesList(state, props),
  selectedSize: selectSize(state, props),
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(EditSizeBlock);
